// extracted by mini-css-extract-plugin
export default {"navItem1":"NavItems_navItem1__Hmcu8","navItem":"NavItems_navItem__9ep02","navItems":"NavItems_navItems__QPxvQ"};